import { Text } from "@mantine/core";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

/**
 * Shared visual shell used by every concrete `*ActorContext` renderer.
 *
 * Centralising this prevents the seven sibling renderers from each
 * re-declaring the same `<Text size="xs" c="dimmed">` shell — when the
 * actor-line typography needs to evolve (colour, density, icons), the
 * change happens here once.
 */
export function ActorContextRow({ children }: Props) {
  return (
    <Text size="xs" c="dimmed">
      {children}
    </Text>
  );
}

/**
 * Truncate an ID for display. Centralised so the actor-context renderers
 * share a single rule and any future UX change (length, ellipsis, copy
 * affordance) lands in one place.
 */
export function truncateId(id: string): string {
  return id.slice(0, 8);
}
